import * as yup from 'yup';
import { Actions } from './index';

export interface User {
    readonly name?: string
    readonly email?: string
    readonly isPaidAccount?: boolean
    readonly numDocsLeft?: number
    readonly planType?: string
    readonly accountDateFormat: string
}

export const userSchema = yup.object<User>({
  name: yup.string().trim(),
  email: yup.string().trim(),
  isPaidAccount: yup.bool(),
  numDocsLeft: yup.number(),
  accountDateFormat: yup.string(),
});

export interface UpdateUserAction {
  type: Actions.UpdateUser,
  payload: Partial<User>,
}

export type UserActions =
  | UpdateUserAction
